import {
  $createRequisites,
  $deleteRequisite,
  $downloadFileByUrl,
  $getRequisites,
  $updateRequisites,
  createRequisites,
  deleteRequisite,
  downloadFileByUrl,
  getRequisites,
  updateRequisites,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    deleteRequisite,
    updateRequisites,
    createRequisites,
    downloadFileByUrl,
    getRequisites,
  },
};

export const $actions = {
  deleteRequisite: $deleteRequisite,
  updateRequisites: $updateRequisites,
  downloadFileByUrl: $downloadFileByUrl,
  getRequisites: $getRequisites,
  createRequisites: $createRequisites,
};
